// data/videoAvailableLibrary.js — the how-to videos shown INSIDE the availability pages:
//
//   staff       the casual's Create Availability tab (CasualsAvailability → CasualsCreate)
//   supervisor  the supervisor's Create Jobs tab (CreateCasualJobs), under the job-type buttons
//
// Two legs, not tiers: a casual sees the staff leg; a supervisor and everyone above them
// (management, admin, IT) sees the supervisor leg. That is decided by which page is open,
// so there is no tier lookup here — the page passes its leg in. Same shape as
// data/videoLibrary.js (declare each video once, compose rows by reference) and the same
// helpers, so the cards and the player are the ones ProfileHome uses.
//
// To add a video: add it to VIDEOS, then reference it from STAFF or SUPERVISOR.
//   url      YouTube link (youtu.be/… or youtube.com/watch?v=…) or a direct .mp4 — anything VideoPlayer takes
//   image    optional thumbnail; omit and the YouTube thumbnail is used
//   minutes  optional, shown as a small "3 min" tag on the card
//   requires optional gate, same keys as map.js itemVisible (e.g. 'casual')

const VIDEOS = {
  postAvailability: { id: 'post-availability', title: 'Extra work availability Staff', summary: 'Pick a day, a week or a month and tell the office where you can work.', url: 'https://youtu.be/1iXzuv7SqXA', minutes: 4 },
  answerOffer:      { id: 'answer-offer',      title: 'My Availability Staff',     summary: 'Accept or decline from Extra work, and what happens next.',   url: 'https://youtu.be/BwSk7CgSC4Q', minutes: 4 },
  staffMessages:    { id: 'staff-messages',    title: 'Job messages',              summary: 'Ask a supervisor about a job before you answer it.',              image: '/static/images/companypic.png', minutes: 3 },   // no url = coming soon
  globalmessagesstaff:       { id: 'global-messages-staff',       title: 'Global Message System',       summary: 'Broadcast to a group or message one person from the bell.',  url: 'https://youtu.be/t6XOiwYtyUA' , minutes: 6 },

  createJob: { id: 'create-job', title: 'Creating a job',
             summary: 'New client, existing site, periodical or ticket → Jobs Available.',
             url: 'https://youtu.be/nujdN1PBxBw', minutes: 3 },
  closedbutton:       { id: 'closed-button',       title: 'Create Jobs Closed Button',        summary: 'How to use the closed button within Create Jobs.',         url: 'https://youtu.be/jqdRCAaISSs', minutes: 3 },
  assignSlot1:       { id: 'assign-slot1',       title: 'Assigning from Open Slots Part 1', summary: 'Find a casual with the day free and send them the job.',           url: 'https://youtu.be/hhpCoVIavtQ', minutes: 3 },
  assignSlot2:       { id: 'assign-slot2',       title: 'Assigning from Open Slots Part 2', summary: 'Find a casual with the day free and send them the job.',           url: 'https://youtu.be/189GIPw9_3w', minutes: 3 },
  responsesRoster:  { id: 'responses-roster',  title: 'Responses, Roster and Job Messages',      summary: 'Approve a finished job and see who worked when.',                  url: 'https://youtu.be/XeZSYY5G93I', minutes: 3 },
  globalmessagessuper:       { id: 'global-messages-super',       title: 'Global Message System',       summary: 'Broadcast to a group or message one person from the bell.',  url: 'https://youtu.be/t6XOiwYtyUA' , minutes: 6 },
};

const STAFF      = [ VIDEOS.globalmessagesstaff,VIDEOS.postAvailability, VIDEOS.answerOffer, VIDEOS.staffMessages];
const SUPERVISOR = [VIDEOS.globalmessagessuper,VIDEOS.createJob,VIDEOS.closedbutton, VIDEOS.assignSlot1, VIDEOS.assignSlot2,VIDEOS.responsesRoster];

export const LEGS = {
  staff:      { heading: 'Work availability — how to', videos: STAFF },
  supervisor: { heading: 'Casual jobs — how to',       videos: SUPERVISOR },
};

/**
 * The videos for one leg as a single shelf row (what VideoShelf takes). Videos gated by
 * `requires` drop out via itemVisible; duplicates are kept once. [] when nothing to show.
 */
export const availableShelvesForUser = (user, leg, { itemVisible }) => {
  const def = LEGS[leg];
  if (!def) return [];
  const seen = new Set();
  const videos = def.videos.filter((v) => {
    if (seen.has(v.id) || !itemVisible(v, user)) return false;
    seen.add(v.id);
    return true;
  });
  return videos.length ? [{ id: `videos-${leg}`, heading: def.heading, videos }] : [];
};
